import { createApp } from 'vue'
import Varyans from './Varyans.vue'
import './assets/global.css'

createApp(Varyans).mount('#varyans')
